
import {
  getUSIEngineInfo,
  loadUSIEngineSetting,
  saveUSIEngineSetting,
  showSelectUSIEngineDialog,
} from "@/ipc/renderer";
import { USIEngineSetting, USIEngineSettings } from "@/settings/usi";
import { Mutation, useStore } from "@/store";
import { ref, onMounted, defineComponent, Ref, computed } from "vue";
import USIEngineOptionDialog from "@/components/dialog/USIEngineOptionDialog.vue";
import { showModalDialog } from "@/helpers/dialog";

export default defineComponent({
  name: "USIEngineManagementDialog",
  components: {
    USIEngineOptionDialog,
  },
  setup() {
    const dialog: Ref = ref(null);
    const optionDialog: Ref<USIEngineSetting | null> = ref(null);
    const setting = ref(new USIEngineSettings());
    const store = useStore();

    store.commit(Mutation.RETAIN_BUSSY_STATE);

    onMounted(async () => {
      showModalDialog(dialog.value);
      try {
        setting.value = await loadUSIEngineSetting();
        store.commit(Mutation.RELEASE_BUSSY_STATE);
      } catch (e) {
        store.commit(Mutation.PUSH_ERROR, e);
        store.commit(Mutation.CLOSE_DIALOG);
      }
    });

    const add = async () => {
      try {
        store.commit(Mutation.RETAIN_BUSSY_STATE);
        const path = await showSelectUSIEngineDialog();
        if (!path) {
          return;
        }
        setting.value.addEngine(await getUSIEngineInfo(path));
      } catch (e) {
        store.commit(Mutation.PUSH_ERROR, e);
      } finally {
        store.commit(Mutation.RELEASE_BUSSY_STATE);
      }
    };

    const remove = (uri: string) => {
      setting.value.removeEngine(uri);
    };

    const openOptions = (uri: string) => {
      optionDialog.value = setting.value.getEngine(uri);
    };

    const saveAndClose = async () => {
      try {
        store.commit(Mutation.RETAIN_BUSSY_STATE);
        await saveUSIEngineSetting(setting.value as USIEngineSettings);
        store.commit(Mutation.CLOSE_DIALOG);
      } catch (e) {
        store.commit(Mutation.PUSH_ERROR, e);
      } finally {
        store.commit(Mutation.RELEASE_BUSSY_STATE);
      }
    };

    const cancel = () => {
      store.commit(Mutation.CLOSE_DIALOG);
    };

    const optionOk = (engine: USIEngineSetting) => {
      setting.value.updateEngine(engine);
      optionDialog.value = null;
    };

    const optionCancel = () => {
      optionDialog.value = null;
    };

    const engines = computed(() => setting.value.engineList);

    return {
      optionDialog,
      dialog,
      engines,
      add,
      remove,
      openOptions,
      saveAndClose,
      cancel,
      optionOk,
      optionCancel,
    };
  },
});
